import { Box, Image, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { Animated } from 'react-native'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { RewardAnimation } from './RewardAnimation'

export const Rewards = ({ collapseAnimation, expandAnimation, setRewardsOffset, setRewardsHeight }: any) => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)

  const [animatedValue] = useState(new Animated.Value(0))

  const startCenterAnimation = ({ delay }: any) => {
    Animated.timing(animatedValue, {
      toValue: expandAnimation ? 1 : 0,
      duration: 500,
      useNativeDriver: true,
      delay: delay ? 200 : undefined,
    }).start()
  }

  const animate = {
    transform: [
      {
        translateY: animatedValue.interpolate({
          inputRange: [0, 1],
          outputRange: [18, 0],
        }),
      },
    ],
  }

  useEffect(() => {
    if (expandAnimation || collapseAnimation) {
      startCenterAnimation({ delay: 200 })
    }
  }, [expandAnimation, collapseAnimation, startCenterAnimation])

  return (
    <Box ph={resPadding * 2} pt={isMob ? 120 : 108} align={'center'}>
      <Box
        flexDirection={'row'}
        onLayout={(evt: any) => [
          setRewardsOffset(evt?.nativeEvent?.layout?.top),
          setRewardsHeight(evt?.nativeEvent?.layout?.height),
        ]}>
        <RewardAnimation
          isLeft={true}
          src={require('../../assets/svg/rewards/reward-box1.svg')}
          expandAnimation={expandAnimation}
          collapseAnimation={collapseAnimation}
        />
        <Animated.View style={[animate, { position: 'absolute', marginTop: isMob ? -8 : -18 }]}>
          <Image
            source={require('../../assets/svg/reward-center.svg')}
            width={isMob ? 98 : 200}
            height={isMob ? 98 : 200}
            resizeMode={'center'}
          />
        </Animated.View>
        <RewardAnimation
          isLeft={false}
          src={require('../../assets/svg/rewards/reward-box2.svg')}
          expandAnimation={expandAnimation}
          collapseAnimation={collapseAnimation}
        />
      </Box>
      <Box position={'absolute'} left={isMob ? resPadding : resPadding * 1.5 + 100} top={isMob ? 300 : 400} bottom={0}>
        <Image
          source={require('../../assets/svg/rewards/img1.svg')}
          width={isMob ? 16 : 45}
          height={isMob ? 16 : 27}
          resizeMode={'center'}
        />
      </Box>
      <Box position={'absolute'} left={isMob ? resPadding + 16 : resPadding * 2 + 60} top={isMob ? 200 : 280}>
        <Image
          source={require('../../assets/svg/rewards/img2.svg')}
          width={isMob ? 21 : 45}
          height={isMob ? 21 : 45}
          resizeMode={'center'}
        />
      </Box>
      <Box position={'absolute'} right={isMob ? resPadding + 50 : resPadding * 2 + 180} top={isMob ? 160 : 200}>
        <Image
          source={require('../../assets/svg/rewards/img3.svg')}
          width={isMob ? 19 : 30}
          height={isMob ? 19 : 30}
          resizeMode={'center'}
        />
      </Box>
      <Box position={'absolute'} right={isMob ? resPadding + 30 : resPadding * 2 + 60} top={isMob ? 200 : 320}>
        <Image
          source={require('../../assets/svg/rewards/img4.svg')}
          width={isMob ? 21 : 45}
          height={isMob ? 21 : 45}
          resizeMode={'center'}
        />
      </Box>
      <Box position={'absolute'} right={isMob ? 18 : resPadding * 2 - 50} bottom={isMob ? 50 : 40}>
        <Image
          source={require('../../assets/svg/rewards/img5.svg')}
          width={isMob ? 16 : 45}
          height={isMob ? 8 : 27}
          resizeMode={'center'}
        />
      </Box>
      <Spacer size={32} />
      <Box mt={isMob ? -80 : -168} maxWidth={isMob ? '100%' : '70%'}>
        <Text
          title={staticStrings.rewards}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 36 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          textAlign={'center'}
        />
        <Spacer size={24} />
        <Text
          title={staticStrings.rewardsSubTitle}
          fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
          fontSize={isMob ? 14 : 24}
          lineHeight={isMob ? 20 : 40}
          letterSpacing={isMob ? 0 : -0.48}
          textAlign={'center'}
          color={isMob ? 'BLACK_75' : 'BLACK_21'}
        />
      </Box>
    </Box>
  )
}
